import styled from '@emotion/styled';
import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { QcsLoadingButton } from './basic/QcsLoadingButton';
import { QcsTypography } from './basic/QcsTypography';
import RefreshIcon from '@mui/icons-material/Refresh';
import axios, { CancelToken } from 'axios';
import { TypographyProps } from '@mui/material';

const SectionHeaderContainer = styled.div(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'space-between',
  gap: '0.5rem',
  marginBottom: '1.5rem',
  [theme.breakpoints.up('sm')]: {
    flexDirection: 'row',
    alignItems: 'center',
  },
}));

const ActionsContainer = styled.div({
  display: 'flex',
  alignItems: 'center',
  gap: '0.5rem',
});

interface Props {
  title?: string | null;
  addText?: string;
  addDisabled?: boolean;
  handleAddClick?: () => void;
  isLoading?: boolean;
  variant?: TypographyProps['variant'];
  children?: React.ReactNode;
  onRefresh?: (cancelToken: CancelToken) => void;
}

export const SectionHeader: FC<Props> = ({ title, addText, addDisabled, handleAddClick, isLoading, variant = 'h4', children, onRefresh }) => {
  const { t } = useTranslation();

  const handleRefresh = () => {
    if (!onRefresh) return;
    onRefresh(axios.CancelToken.source().token);
  };

  return (
    <SectionHeaderContainer>
      {!!title && <QcsTypography variant={variant}>{t(title)}</QcsTypography>}
      <ActionsContainer>
        {onRefresh && (
          <QcsLoadingButton variant="outlined" onClick={handleRefresh} loading={isLoading}>
            <RefreshIcon />
          </QcsLoadingButton>
        )}
        {children}
        {!!handleAddClick && !!addText && (
          <QcsLoadingButton variant="contained" onClick={handleAddClick} disabled={addDisabled} loading={isLoading}>
            {t(addText)}
          </QcsLoadingButton>
        )}
      </ActionsContainer>
    </SectionHeaderContainer>
  );
};
